export const lessonPhases = [
  {
    range: 'Lessons 1–3',
    title: 'Explore the ball',
    lessons: ['Ball and space familiarity', 'Pass and receive with intent', 'Pass and move'],
  },
  {
    range: 'Lessons 4–6',
    title: 'Aim and advance',
    lessons: ['Throw at a target', 'Advance and choose', 'Find space to help'],
  },
  {
    range: 'Lessons 7–9',
    title: 'Decide together',
    lessons: ['Solve a 2v1', 'Support in a 3v2', '3v3 toward a zone'],
  },
  {
    range: 'Lessons 10–12',
    title: 'Play the game',
    lessons: ['3v3 toward targets', 'Integrate and switch roles', 'Mini-handball festival'],
  },
];
